import styled from 'styled-components';
import {colors, fonts} from '../../../utils/styled/_variables.styled';
import "../../../base/styled/_typograhpy.style";

export const InfiosTextAreaWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;

  span {
    margin-top: 8px;
    color: ${colors.error};
  }

  &:after {
    content: '${props => props.helpMessage}';
    display: flex;
    position: absolute;
    bottom: 12px;
    right: 12px;
    font-family: ${fonts.AeonikPro};
    font-style: normal;
    font-weight: 300;
    font-size: 19px;
    line-height: 150%;
    color: ${colors.gray5};
  }
`

export const InfiosTextArea = styled.textarea`
  display: flex;
  height: 263px;
  width: 100%;
  padding: 12px 12px 44px;
  border: 1px solid ${colors.infiosGray};
  outline: none;
  resize: none;
  font-size: 19px!important;

  & ~ label ~ span {
    display: none;
  }

  &.error {
    border: 1px solid ${colors.error};
  }

  &.error ~ label ~ span {
    display: block;
  }

  &:hover {
    border: 2px solid ${colors.blue};
  }

  &:focus {
    border: 2px solid ${colors.blue};
  }

  &:focus ~ label, ~ .hasValue {
    top: -5px;
    left: 8px;
    font-size: 10px;
    font-weight: 600;
    color: ${colors.infiosGray};
    background-color: #fff;
    padding: 0 5px 0 5px;
  }

  &:disabled {
    background-color: ${colors.gray1};
    border: 1px solid ${colors.gray1};
    pointer-events: none;
  }
`
